import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  overscroll-behavior: contain;

  textarea.editable {
    border: 0;
    margin: 0;
    padding: 0;
    font-size: 2.2rem;
    font-family: Inter;
    width: 100%;
    font-weight: 500;
    text-align: left;
    display: block;
    text-align: left;
    outline: none;
    line-height: 2.6rem;
    background: transparent;
    resize: none;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    color: var(--icon-button-fill);
    -webkit-text-fill-color: var(--icon-button-fill);
  }

  &.editing {
    overflow-y: scroll;

    textarea.editable {
      cursor: text;
    }
  }
`;
